import React, { useState } from "react";

function Nav() {
  // State to manage the visibility of the menu
  const [menuVisible, setMenuVisible] = useState(false);

  // Function to toggle the menu visibility
  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  return (
    <>
      <div
        className={`th-menu-wrapper ${menuVisible ? "th-body-visible" : ""}`}
      >
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle" onClick={toggleMenu}>
            <i className={`fal ${menuVisible ? "fa-times" : "fa-bars"}`} />
          </button>
          <div className="mobile-logo">
            <a href="/">
              <img alt="" src="images/imt-small.png" />
            </a>
          </div>
          <div className="th-mobile-menu">
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li className="menu-item-has-children">
                <a href="#">Services</a>
                <ul className="sub-menu">
                  <li>
                    <a href="/services">Services</a>
                  </li>
                  <li>
                    <a href="/soil">Soil Testing</a>
                  </li>
                  <li>
                    <a href="/geophysical">Geophysical Testing</a>
                  </li>
                  <li>
                    <a href="/concrete">Concrete Testing</a>
                  </li>
                  <li>
                    <a href="/asphalt">Asphalt Testing</a>
                  </li>
                </ul>
              </li>

              <li>
                <a href="/careers">Careers</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <header className="th-header header-layout7">
        <div className="header-top py-2">
          <div className="container">
            <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 header-row">
              {/* Email */}
              <div className="d-flex align-items-center gap-2">
                <i className="fal fa-envelope" />
                <a href="mailto:info@integrity-mt.com" className="header-link">
                  info@integrity-mt.com
                </a>
              </div>

              {/* Phone */}
              <div className="d-flex align-items-center gap-2">
                <i className="fal fa-phone" />
                <a href="tel:+1-813-994-1164" className="header-link">
                  1 (813) 994 1164
                </a>
              </div>

              {/* Address */}
              <div className="d-flex align-items-center gap-2">
                <i className="fal fa-location-dot" />
                <a
                  href="https://maps.app.goo.gl/2tD3gXqawSEsdn2H7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header-link"
                >
                  6151 Old Pasco Rd, Wesley Chapel, FL 33544
                </a>
              </div>

              {/* Social Icons - hidden on mobile */}
              <div className="d-none d-md-flex align-items-center gap-2">
                <a
                  target="_blank"
                  href="https://www.facebook.com/Integritymaterialstesting"
                  rel="noopener noreferrer"
                  className="social-icon-clean"
                >
                  <i className="fab fa-facebook-f" />
                </a>

                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/integrity-mt"
                  rel="noopener noreferrer"
                  className="social-icon-clean"
                >
                  <i className="fab fa-linkedin-in" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="sticky-wrapper">
          <div className="sticky-active">
            <div className="menu-area">
              <div className="container">
                <div className="row align-items-center justify-content-between">
                  <div className="col-auto">
                    <div className="logo-style1">
                      <a href="/">
                        <img alt="" src="images/imt-small.png" />
                      </a>
                    </div>
                  </div>
                  <div className="col-auto">
                    <div className="row align-items-center">
                      <div className="col-auto">
                        <nav className="main-menu d-none d-lg-inline-block">
                          <ul>
                            <li>
                              <a href="/">Home</a>
                            </li>
                            <li>
                              <a href="/about">About Us</a>
                            </li>
                            <li className="menu-item-has-children">
                              <a href="#">Services</a>
                              <ul className="sub-menu">
                                <li>
                                  <a href="/services">Services</a>
                                </li>
                                <li>
                                  <a href="/soil">Soil Testing</a>
                                </li>
                                <li>
                                  <a href="/geophysical">Geophysical Testing</a>
                                </li>
                                <li>
                                  <a href="/concrete">Concrete Testing</a>
                                </li>
                                <li>
                                  <a href="/asphalt">Asphalt Testing</a>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <a href="/careers">Careers</a>
                            </li>
                          </ul>
                        </nav>
                        <button
                          className="th-menu-toggle d-inline-block d-lg-none"
                          type="button"
                          onClick={toggleMenu}
                        >
                          <i
                            className={`fal ${
                              menuVisible ? "fa-times" : "fa-bars"
                            }`}
                          />
                        </button>
                      </div>
                      <div className="col-auto d-none d-xl-block">
                        <div className="header-button">
                          <a className="th-btn style3 ml-25" href="/contact">
                            Contact for scheduling
                            <i className="fas fa-arrow-right ms-2" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <style>
        {`
/* Wrapper */
.header-top {
  background: #ffffff;
  border-bottom: 1px solid #e6e6e6;
  font-size: 14px;
}

.header-row i {
  color: #077325;
  font-size: 15px;
}

/* Contact links */
.header-link {
  color: #000;
  text-decoration: none;
  font-weight: 500;
  transition: 0.25s ease;
}

.header-link:hover {
  color: #077325;
}

/* ----- SHARP SOCIAL ICONS (square + standout) ----- */
.social-icon-clean {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #000;
  color: #000;
  font-size: 15px;
  transition: 0.25s ease;
}

.social-icon-clean:hover {
  background: #077325;
  border-color: #077325;
  color: #ffffff !important;
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.social-icon-clean:hover i {
  color: #ffffff !important;
}

/* Responsive */
@media (max-width: 576px) {
  .header-row {
    gap: 10px;
  }
  .social-icon-clean {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }
}


`}
      </style>
    </>
  );
}

export default Nav;
